import React, { Component } from "react";
import MaterialTable from "material-table";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import PropTypes from 'prop-types';
import { IsEmpty } from '../../../common/checks';

class CustomList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      location: null,
      open: false
    }
  }

  componentDidMount() {
    var customLocations = this.props.promoLocations.filter(location => location.outletId === null || location.outletId === '');
    this.setState({ posts: customLocations });

    // update the custom location label count.
    this.props.updateCustomLocationCount( !IsEmpty(customLocations) ? customLocations.length : 0 )
  }

  componentDidUpdate(prevProps, prevState) {
    let prevCustomLocations = prevState.posts;
    let currCustomLocations = this.props.promoLocations.filter(location => location.outletId === null || location.outletId === '');
    if (prevCustomLocations.length !== currCustomLocations.length) {
      this.setState({ posts: currCustomLocations });

      // update the custom location label count.
      this.props.updateCustomLocationCount( !IsEmpty(currCustomLocations) ? currCustomLocations.length : 0 )
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  handleDelete = async () => {
    await this.props.handleDeleteCustomLocation(this.state.posts, this.state.location);
    this.handleClose();
  }

  render() {
    const { handleClose, handleDelete } = this;
    const { onOpenModal } = this.props;
    const { posts, open } = this.state;
    return (
      <div>
        <MaterialTable
          title=""
          columns={[
            { title: 'Located In', field: 'locatedIn' },
            { title: 'Address', field: 'address' },
            { title: 'Postal Code', field: 'postalCode' },
            { title: 'Remarks', field: 'remarks' }
          ]}
          data={posts ? posts : []}
          actions={[
            {
              icon: "edit",
              tooltip: "Update Location",
              onClick: (event, location) => {
                return onOpenModal('Update', posts, location)
              }
            },
            {
              icon: "delete",
              tooltip: "Delete Location",
              onClick: (event, location) => {
                this.setState({
                  open: true,
                  location: location
                });
              }
            }
          ]}
          options={{
            actionsColumnIndex: -1,
            search: true,
            sorting: true,
            paging: true,
            emptyRowsWhenPaging: false
          }}
        />
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth size="sm"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Custom Location"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this custom location?
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">Cancel</Button>
            <Button onClick={handleDelete} color="secondary">Delete</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

CustomList.propTypes = {
  updateCustomLocationCount: PropTypes.func
}

CustomList.defaultProps = {
  updateCustomLocationCount: () => {},
}
export default CustomList;